import './free_text_attribute_view.js.coffee'

class Customer.EmailAttributeView extends Customer.FreeTextAttributeView
  valueTemplate: JST['backbone/templates/customer/custom_attributes/values/email']

  getErrorMessages: (_event) ->
    [@_invalidEmailMessage()]

  _invalidEmailMessage: ->
    I18n.t('monitoring.conversation_attributes.errors.email.invalid')
